// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eMXz","select":"styles_select__3amXH"};